/**
 * Total Value Planner route (#1116): /total-value-planner.
 * A top-level page under Analytics with its own sidebar highlight. Gated on
 * tvp:view; committing is separately gated on tvp:commit inside the page.
 */
import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { TotalValuePlannerPage } from '@/components/features/tvp/TotalValuePlannerPage'

export const Route = createFileRoute('/_authenticated/total-value-planner')({
  component: () => (
    <PermissionRouteGuard resource="tvp" action="view">
      <TotalValuePlannerPage />
    </PermissionRouteGuard>
  ),
})
